import { NgModule } from '@angular/core';

import { SharedModule }                 from '../../app-lite/shared/shared.module';
import { TableModule }                  from '../table/table.module';
import { VendorActionsComponent }       from './vendor.actions.component';
import { VendorIntegrationsService }    from './vendor-integrations.service';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorChangeComponent }         from './vendor-change.component';
import { VendorComponent }              from './vendor.component';
import { VendorLinkedVendorsComponent }  from './vendor-linked-vendors.component';
import { VendorManuallyLinkComponent }   from './vendor-manually-link.component';
import { VendorQuickAddComponent }       from './vendor.quick-add.component';
import { VendorResolveMatchesComponent } from './vendor-resolve-matches.component';
import { VendorSearchControlComponent }  from './vendor.search-control.component';
import { VendorSearchService }           from './vendor.search.service';
import { VendorsListComponent }         from './vendors.list.component';

import {
  VendorBranchInvoicesPlaceholderComponent,
  VendorBranchPaymentsPlaceholderComponent,
  VendorOrdersPlaceholderComponent,
  VendorInvoicesPlaceholderComponent,
  VendorPaymentsPlaceholderComponent,
  VendorBilledPlaceholderComponent,
} from './vendor.placeholder-components';

@NgModule({
  declarations: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorBilledPlaceholderComponent,
    VendorBranchInvoicesPlaceholderComponent,
    VendorBranchPaymentsPlaceholderComponent,
    VendorChangeComponent,
    VendorComponent,
    VendorInvoicesPlaceholderComponent,
    VendorLinkedVendorsComponent,
    VendorManuallyLinkComponent,
    VendorOrdersPlaceholderComponent,
    VendorPaymentsPlaceholderComponent,
    VendorQuickAddComponent,
    VendorResolveMatchesComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  entryComponents: [
    VendorActionsComponent,
    VendorActivityLogsComponent,
    VendorBilledPlaceholderComponent,
    VendorBranchInvoicesPlaceholderComponent,
    VendorBranchPaymentsPlaceholderComponent,
    VendorChangeComponent,
    VendorComponent,
    VendorInvoicesPlaceholderComponent,
    VendorLinkedVendorsComponent,
    VendorManuallyLinkComponent,
    VendorOrdersPlaceholderComponent,
    VendorPaymentsPlaceholderComponent,
    VendorQuickAddComponent,
    VendorResolveMatchesComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  exports: [
    VendorBilledPlaceholderComponent,
    VendorBranchInvoicesPlaceholderComponent,
    VendorBranchPaymentsPlaceholderComponent,
    VendorInvoicesPlaceholderComponent,
    VendorOrdersPlaceholderComponent,
    VendorPaymentsPlaceholderComponent,
    VendorSearchControlComponent,
    VendorsListComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    VendorIntegrationsService,
    VendorSearchService
  ]
})
export class VendorsModule {}